// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.emailverification.RentalManagerUserEmailVerificationV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken,
  RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode,
  RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode,
  RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ContactEmailVerificationSendVerificationCodeRequestDto,
  ContactEmailVerificationValidateVerificationCodeRequestDto,
  RentalManagerContactEmailVerificationCodeValidationDto,
  RentalManagerContactEmailVerificationEmailVerificationDto,
  UserEmailVerificationSendSecurityTokenRequestDto,
  UserEmailVerificationSendSecurityTokenV2ResponseWebDto,
  UserEmailVerificationVerifySecurityTokenRequestDto,
  UserEmailVerificationVerifySecurityTokenV2ResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Args {
  postData: UserEmailVerificationSendSecurityTokenRequestDto;
}

export type RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Options = UseMutationOptions<
  UserEmailVerificationSendSecurityTokenV2ResponseWebDto,
  unknown,
  RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Args
>;

/**
 * Email the email verification link to the user
 */
export const useRentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Args) =>
      RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken(args.postData, httpClient),
  });
};

export interface RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Args {
  postData: ContactEmailVerificationSendVerificationCodeRequestDto;
}

export type RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Options = UseMutationOptions<
  RentalManagerContactEmailVerificationEmailVerificationDto,
  unknown,
  RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Args
>;

/**
 * Email the contact email verification code to the user
 */
export const useRentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Args) =>
      RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode(args.postData, httpClient),
  });
};

export interface RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Args {
  postData: ContactEmailVerificationValidateVerificationCodeRequestDto;
}

export type RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Options = UseMutationOptions<
  RentalManagerContactEmailVerificationCodeValidationDto,
  unknown,
  RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Args
>;

/**
 * Validate code for contact email verification
 */
export const useRentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Args) =>
      RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode(args.postData, httpClient),
  });
};

export interface RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Args {
  postData: UserEmailVerificationVerifySecurityTokenRequestDto;
}

export type RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Options = UseMutationOptions<
  UserEmailVerificationVerifySecurityTokenV2ResponseWebDto,
  unknown,
  RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Args
>;

/**
 * Verify securityToken from email verification
 */
export const useRentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Args) =>
      RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken(args.postData, httpClient),
  });
};
